<template>
  <div class="new-page-con">
    <div class="layout_header">
      <Header> </Header>
    </div>
    <div class="dataapi-page dataServices-page" ref="scrollContainer">
      <!-- 工具栏 -->
      <ToolBar
        :ToolBarData="ToolBarData"
        @select="triggerIsSelect"
        @reselect="triggerIsReselect"
        @download="triggerIsDownload"
      />
      <div
        class="apilistfix"
        v-if="
          ['APIHomepage_more', 'APIHomepage_more_detail'].includes(routeName)
        "
      >
        <div
          @click="apilistClick()"
          class="api-type"
          v-for="(item, index) in apimodulesList"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div
        :class="['dataapi-content', asideWidth == '70px' ? 'asideWidth70' : '']"
      >
        <el-container>
          <el-aside :width="asideWidth" class="aside-fixed">
            <div>
              <div class="menu-item-two">Data Library</div>
              <div class="menu-item-two-child">
                <router-link :to="{ name: 'dataLibrary' }">
                  <div
                    class="menu-item-two-child-item"
                    :class="[
                      routeName.includes('apiDocumentation')
                        ? 'menu-item-two-active'
                        : '',
                    ]"
                  >
                    <img
                      :src="[
                        routeName.includes('apiDocumentation')
                          ? require('@/assets/images/dataServices/dataLibrary-img/icon1-active.svg')
                          : require('@/assets/images/dataServices/dataLibrary-img/icon1.svg'),
                      ]"
                      alt=""
                    />
                    <span v-if="asideWidth == '240px'"> API Documentation</span>
                  </div>
                </router-link>
                <router-link :to="{ name: 'dataDictionary' }">
                  <div
                    class="menu-item-two-child-item"
                    :class="[
                      routeName.includes('dataDictionary')
                        ? 'menu-item-two-active'
                        : '',
                    ]"
                  >
                    <img
                      :src="[
                        routeName.includes('dataDictionary')
                          ? require('@/assets/images/dataServices/dataLibrary-img/icon2-active.svg')
                          : require('@/assets/images/dataServices/dataLibrary-img/icon2.svg'),
                      ]"
                      alt=""
                    />
                    <span v-if="asideWidth == '240px'"> Data Dictionary</span>
                  </div>
                </router-link>
                <router-link :to="{ name: 'websiteNavigation' }">
                  <div
                    class="menu-item-two-child-item"
                    :class="[
                      routeName.includes('websiteNavigation')
                        ? 'menu-item-two-active'
                        : '',
                    ]"
                  >
                    <img
                      :src="[
                        routeName.includes('websiteNavigation')
                          ? require('@/assets/images/dataServices/dataLibrary-img/icon3-active.svg')
                          : require('@/assets/images/dataServices/dataLibrary-img/icon3.svg'),
                      ]"
                      alt=""
                    />
                    <span v-if="asideWidth == '240px'">
                      Website Navigation</span
                    >
                  </div>
                </router-link>
              </div>
            </div>
            <div class="aside-status-icon">
              <img
                src="../../../assets/images/dataServices/dataapi-img/foldup-aside.svg"
                alt=""
                @click="foldupAsideClick()"
                v-if="asideWidth == '240px'"
              />
              <img
                src="../../../assets/images/dataServices/dataapi-img/expand-aside.svg"
                alt=""
                @click="expandAsideClick()"
                v-if="asideWidth == '70px'"
              />
            </div>
          </el-aside>
          <el-main class="dataapi-content-main">
            <router-view
              :key="$route.fullPath"
              :scrollContainer="scrollContainerRef"
              :TesRecordsPageData="TesRecordsPageData"
              @update-selection="handleSelectionChange"
            />
          </el-main>
        </el-container>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../layout/header.vue";
import ToolBar from "../components/toolBar.vue";
import {
  downloadPatchCategory,
  downloadPatchApi
} from "@/api/dataServicesApi";
export default {
  name: "DataLibrary",
  components: {
    Header,
    ToolBar,
  },
  data() {
    return {
      asideWidth: "240px",
      routeName: "",
      TesRecordsPageData: {
        isShowCheckBtn_APID: false,
        isShowCheckBtn_DataD: false,
        isShowCheckBtn_WebN: false,
        isReselectCheckBtn_APID: false,
        isReselectCheckBtn_DataD: false,
        isReselectCheckBtn_WebN: false,
      },
      ToolBarData: {},
      scrollContainerRef: null,
    };
  },
  mounted() {
    this.scrollContainerRef = this.$refs.scrollContainer;
    this.$store.dispatch("app/setThemColor", "#B98B73");
    this.$store.dispatch("app/setSearchType", "dataServices");
    // 获取当前路径 给菜单高亮
    this.routeName = this.$route.name;
  },
  computed: {},
  watch: {
    // 监听整个 $route 对象的变化（路径、query、params 等）
    $route: {
      handler(to, from) {
        this.routeName = to.name;
        if (this.routeName === "apiDocumentation") {
          this.ToolBarData = {
            isSelectDisabled: false,
            isReselectDisabled: false,
            isDownloadDisabled:true,
          };
        } else if (this.routeName === "dataDictionary") {
          this.ToolBarData = {
            isSelectDisabled: false,
            isReselectDisabled: false,
            isDownloadDisabled:true,
          };
        } else if (this.routeName === "websiteNavigation") {
          this.ToolBarData = {
            isSelectDisabled: false,
            isReselectDisabled: false,
            isDownloadDisabled:true,
          };
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    foldupAsideClick() {
      this.asideWidth = "70px";
    },
    expandAsideClick() {
      this.asideWidth = "240px";
    },
    // 点击select工具页面的复选框才会显示
    triggerIsSelect() {
      if (this.routeName === "apiDocumentation") {
        this.TesRecordsPageData.isShowCheckBtn_APID =
          !this.TesRecordsPageData.isShowCheckBtn_APID;
      } else if (this.routeName === "dataDictionary") {
        this.TesRecordsPageData.isShowCheckBtn_DataD =
          !this.TesRecordsPageData.isShowCheckBtn_DataD;
      } else if (this.routeName === "websiteNavigation") {
        this.TesRecordsPageData.isShowCheckBtn_WebN =
          !this.TesRecordsPageData.isShowCheckBtn_WebN;
      }
    },
    // 取消所有选中的复选框
    triggerIsReselect() {
      if (this.routeName === "apiDocumentation") {
        this.TesRecordsPageData.isReselectCheckBtn_APID = true;
        this.$nextTick(() => {
          // 点击后重置下 方便多次点击
          setTimeout(() => {
            this.TesRecordsPageData.isReselectCheckBtn_APID = false;
          }, 100);
        });
      } else if (this.routeName === "dataDictionary") {
        this.TesRecordsPageData.isReselectCheckBtn_DataD = true;
        this.$nextTick(() => {
          // 点击后重置下 方便多次点击
          setTimeout(() => {
            this.TesRecordsPageData.isReselectCheckBtn_DataD = false;
          }, 100);
        });
      } else if (this.routeName === "websiteNavigation") {
        this.TesRecordsPageData.isReselectCheckBtn_WebN = true;
        this.$nextTick(() => {
          // 点击后重置下 方便多次点击
          setTimeout(() => {
            this.TesRecordsPageData.isReselectCheckBtn_WebN = false;
          }, 100);
        });
      }
    },
    // 接收子组件传来的数据
    handleSelectionChange(data,type) {
      this.selectedApiData = data;
      if(!this.selectedApiData.length){
        // 没有选api列表
        this.ToolBarData.isDownloadDisabled = true
      }else{
        this.ToolBarData.isDownloadDisabled = false
      }
      this.downloadType=type
      console.log("父组件收到选中数据:", data,type);
    },
    // 点击下载api接口文档zip
    async triggerIsDownload() {
      if (this.downloadType==1) {
        let params = {
          categoryIds: this.selectedApiData,
        };
        downloadPatchCategory(params).then((res) => {
          if (res) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.download = "api.zip";
            link.click();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if(this.downloadType==2) {
        let params = {
          apiIds: this.selectedApiData,
        };
        downloadPatchApi(params).then((res) => {
          if (res) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.download = "api.zip";
            link.click();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.dataapi-page {
  overflow: auto;
}
.dataapi-content {
  margin: 76px 20px 20px 20px;
}
.dataapi-content .el-container .el-aside {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 14px;
  position: fixed;
  top: 165px;
  left: 20px;
  height: calc(100vh - 194px);
  min-height: 350px;
  /* width: 240px !important; 覆盖 el-aside 默认样式 */
  z-index: 100;
  background-color: #fff;
  border-right: 1px solid #ebeef5;
  overflow-y: auto; /* 如果菜单项太多，允许菜单自身滚动 */
}

.menu-item-first {
  width: 100%;
  height: 48px;
  line-height: 48px;
  padding: 0 14px;
  font-size: 18px;
  color: #1a2332;
  border: 1px solid #b98b73;
  border-radius: 8px;
  margin-bottom: 28px;
  cursor: pointer;
}
.menu-item-first img {
  width: 28px;
  height: 28px;
  vertical-align: middle;
}
.menu-item-first-active {
  background: linear-gradient(180deg, #ecab89 0%, #ffffff 62%);
}
.menu-item-two {
  font-size: 16px;
  color: #b98b73;
  margin-bottom: 14px;
}
.menu-item-two-child {
  font-size: 16px;
}
.menu-item-two-child .menu-item-two-child-item {
  margin-bottom: 8px;
  color: #666666;
  padding: 9px 12px;
  background: transparent;
  border-radius: 8px;
}
.menu-item-two-child .menu-item-two-child-item img {
  vertical-align: middle;
  width: 18px;
  height: 18px;
  margin-right: 15px;
}
.menu-item-two-child .menu-item-two-child-item.menu-item-two-active {
  color: #1a2332;
  background: #f2f3f7;
}
.dataapi-content-main {
  margin: 0 20px 0px 260px;
  padding: 0;
  /* min-height: 100vh;  */
}
/* 展开收起 */
.aside-status-icon {
  border-top: 1px solid #cccccc;
  position: absolute;
  bottom: 10px;
  width: 200px;
  padding: 20px 0 10px 0;
  cursor: pointer;
}
.asideWidth70 .dataapi-content-main {
  margin-left: 90px;
}
.asideWidth70 .aside-status-icon {
  width: 30px;
}
.asideWidth70 .menu-item-first {
  padding: 0 6px;
}
.asideWidth70 .menu-item-first img {
  margin-right: 0px;
}
/* 整个滚动条 */
.dataapi-content-main::-webkit-scrollbar {
  width: 2px !important; /* 垂直滚动条宽度 */
  height: 2px !important; /* 水平滚动条高度 */
}
.apilistfix {
  height: 50px;
  background: #b98b73;
  display: flex;
  justify-content: center;
  gap: 1rem;
  position: sticky;
  top: 66px;
  z-index: 101;
  align-items: center;
}
.apilistfix .api-type {
  padding: 5px 10px;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 10px;
  font-size: 14px;
  cursor: pointer;
}
/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
  /* 字体 标题改成20px */
  /* 字体 内容改成16px 包括按钮里字体*/
  /* 圆角 改成10px */
  /* padding *0.75 */
  /* margin *0.75 */
   /* 表格 表头高度 44px 内容高度50px */
   .dataapi-content {
    margin-top: 60px;
  }
   .dataapi-content .el-container .el-aside {
    height: calc(100vh - 138px);
    top: 118px;
  }
}
@media (max-width: 1440px) {
  .dataapi-content {
    margin-top: 60px;
  }
  .dataapi-content .el-container .el-aside {
    height: calc(100vh - 138px);
    top: 118px;
    left: 20px;
  }
}
</style>
